import { useQuery } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { error } from 'react-notification-system-redux';
import { VEHICLE_WIDGET_STATUS_ENUM, VehicleStatusType } from './vehicle.types';
import { getVehicleStatusQuery } from './vehicle.query';
import { notificationsConfig } from '../../config/constants';
export const useVehicleQuery = () => {
    const dispatch = useDispatch();
    return useQuery({
        queryKey: ['status'],
        queryFn: () => getVehicleStatusQuery(),
        select: (data) => {
            const final = {
                [VEHICLE_WIDGET_STATUS_ENUM.ACTIVE]: 0,
                [VEHICLE_WIDGET_STATUS_ENUM.INACTIVE]: 0,
                [VEHICLE_WIDGET_STATUS_ENUM.IDLE]: 0,
            };
            const active = [VehicleStatusType.HighWorkload, VehicleStatusType.Working, VehicleStatusType.On];
            const idle = [VehicleStatusType.Idle, VehicleStatusType.LongIdle];
            const inactive = [VehicleStatusType.Off, VehicleStatusType['N/A']];
            data.forEach((vehicle) => {
                if (active.includes(vehicle.status)) {
                    final[VEHICLE_WIDGET_STATUS_ENUM.ACTIVE] += vehicle.totalCount;
                }
                if (idle.includes(vehicle.status)) {
                    final[VEHICLE_WIDGET_STATUS_ENUM.IDLE] += vehicle.totalCount;
                }
                if (inactive.includes(vehicle.status)) {
                    final[VEHICLE_WIDGET_STATUS_ENUM.INACTIVE] += vehicle.totalCount;
                }
            });
            return final;
        },
        onError: () => {
            dispatch(error({
                translationKey: 'widget:widget:cant_load_status',
                ...notificationsConfig.defaultConf,
            }));
        },
    });
};
//# sourceMappingURL=useVehicleQuery.js.map